<mat-toolbar class="d-flex flex-space-between mat-elevation-z3" color="primary">
    <button [routerLink]="['/timeline']" aria-label="Home" mat-icon-button matTooltip="Home">
        <img alt="Virtual Memory Box Logo" height="24" ngSrc="assets/images/vmb.svg" width="24">
    </button>
</mat-toolbar>
<main class="minFullHeight" role="main">
    <div class="container d-flex justify-content-center">
        <div class="d-flex flex-column">
            <div>
                <mat-card class="main-card">
                    <mat-card-content>
                        <div class="headerRow">
                            <div class="logoSection">
                                <img alt="Virtual Memory Box Logo" class="my-10 mini-logo"
                                     height="60" ngSrc="assets/images/vmb.svg" width="60">
                            </div>
                            <div class="titleSection">
                                <h1 class="f-20">Hello {{ user | nameDisplay }}, Welcome To Virtual Memory Box!</h1>
                            </div>
                            <div class="imgSection">
                                @if (councilLogo) {
                                    <img [alt]=" authorityName + ' Logo'" [ngSrc]="councilLogo"
                                         class="my-10 mini-logo" height="60"
                                         width="60">
                                }
                            </div>
                        </div>
                        <mat-divider class="mb-20"></mat-divider>
                        <form [formGroup]="signupForm" class="thirdGrid mt-10">
                            <div class="pb-10 px-20">
                                @if (showCropper) {
                                    <div>
                                        <image-cropper
                                                (imageCropped)="imageCropped($event)"
                                                [aspectRatio]="1"
                                                [imageChangedEvent]="imageChangedEvent"
                                                [maintainAspectRatio]="true"
                                                [resizeToWidth]="250"
                                                aria-label="Profile picture cropper (optional, the default centres the crop)"
                                                format="png"
                                        ></image-cropper>
                                    </div>
                                }
                                <img [src]="imgURL" alt="Profile Picture" class="w-100 imgControl">
                                <div class="flex-row flex-space-around">
                                    <div>
                                        <button (click)="fileInput.click()" (keyup.enter)="fileInput.click()"
                                                color="primary" mat-raised-button>
                                            <span>Select New Profile Picture</span>
                                            <input #fileInput (change)="onFileChanged($event)"
                                                   accept="image/png, image/jpeg" class="d-none"
                                                   type="file"/>
                                        </button>
                                    </div>
                                    @if (imgURL != 'assets/images/blankProfile.png' && imgURL != this.user?.photo) {
                                        <div>
                                            <button (click)="removeImage()" (keyup.enter)="removeImage()" color="warn"
                                                    mat-raised-button>Cancel
                                            </button>
                                        </div>
                                    }
                                </div>

                            </div>
                            <div class="fieldContainer signupForm">
                                <mat-form-field appearance="outline" color="primary">
                                    <mat-label>First Name</mat-label>
                                    <input [readonly]="true" class="readonly-disabled" formControlName="first_name"
                                           matInput
                                           type="text">
                                    <button aria-label="First name: if you believe this field is incorrect please contact an administrator to change it"
                                            mat-icon-button matSuffix
                                            matTooltip="If you believe this field is incorrect please contact an administrator to change it">
                                        <mat-icon>info</mat-icon>
                                    </button>
                                </mat-form-field>
                                <mat-form-field appearance="outline" color="primary">
                                    <mat-label>Last Name</mat-label>
                                    <input [readonly]="true" class="readonly-disabled" formControlName="last_name"
                                           matInput
                                           type="text">
                                    <button aria-label="Last name: if you believe this field is incorrect please contact an administrator to change it"
                                            mat-icon-button matSuffix
                                            matTooltip="If you believe this field is incorrect please contact an administrator to change it">
                                        <mat-icon>info</mat-icon>
                                    </button>
                                </mat-form-field>
                                <mat-form-field appearance="outline" color="primary">
                                    <mat-label>Email</mat-label>
                                    <input [readonly]="true" class="readonly-disabled" formControlName="email" matInput
                                           type="email">
                                    <button aria-label="Email: if you believe this field is incorrect please contact an administrator to change it"
                                            mat-icon-button matSuffix
                                            matTooltip="If you believe this field is incorrect please contact an administrator to change it">
                                        <mat-icon>info</mat-icon>
                                    </button>
                                </mat-form-field>
                                <mat-form-field appearance="outline" color="primary">
                                    <mat-label>Username</mat-label>
                                    <input [readonly]="true" class="readonly-disabled" formControlName="username"
                                           matInput
                                           type="text">
                                    <button aria-label="Username: if you believe this field is incorrect please contact an administrator to change it"
                                            mat-icon-button matSuffix
                                            matTooltip="If you believe this field is incorrect please contact an administrator to change it">
                                        <mat-icon>info</mat-icon>
                                    </button>
                                </mat-form-field>
                                @if (this.user?.role?.role_type == 'young_person' && !this.user?.dob) {
                                    <div>
                                        <mat-form-field appearance="outline" class="w-100" color="primary">
                                            <mat-label>Date Of Birth</mat-label>
                                            <input [matDatepicker]="picker" [max]="maxDate" formControlName="dob"
                                                   matInput required>
                                            <mat-hint>DD/MM/YYYY</mat-hint>
                                            <mat-datepicker-toggle [for]="picker" matIconSuffix></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                            @if (signupForm.controls['dob'].hasError('matDatepickerParse')) {
                                                <mat-error>
                                                    Invalid date format. Please use DD/MM/YYYY.
                                                </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>
                                }
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>About Me</mat-label>
                                    <textarea #description formControlName="about" matInput
                                              maxlength="400"></textarea>
                                    <app-emoji-menu [form]="signupForm" [input]="'about'"
                                                    matSuffix></app-emoji-menu>
                                    <mat-hint align="end">{{ description?.value?.length }} / 400</mat-hint>
                                    @if (signupForm.controls['about'].hasError('required')) {
                                        <mat-error>
                                            This field is required
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <mat-slide-toggle class="center" color="primary"
                                                  formControlName="emailNotifications"
                                                  ngDefaultControl>
                                    Email Notifications
                                </mat-slide-toggle>
                            </div>

                        </form>
                    </mat-card-content>
                    <mat-card-actions class="text-center">
                        <button (click)="registerCheck()" (keyup.enter)="registerCheck()"
                                [attr.aria-busy]="loading"
                                [disabled]="signupForm.invalid || loading || signupForm.value['emailConfirm'] !== signupForm.value['email']"
                                class="mx-auto my-10"
                                color="primary" mat-flat-button>
                            Register
                            @if (loading) {
                                <mat-spinner [diameter]="24" aria-label="Registering" class="ms-2"></mat-spinner>
                            }
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>
        </div>
    </div>
</main>
<app-footer></app-footer>
